import type { enDataLifecycle } from '../en/data-lifecycle';

export const idDataLifecycle: Record<keyof typeof enDataLifecycle, string> = {
  'bo.data.nav': 'Data & privasi',
  'bo.data.title': 'Data & privasi',
  'bo.data.subtitle':
    'Ekspor semua data {tenant}, lihat berapa lama setiap jenis data disimpan, atau hentikan langganan.',
  'bo.data.noPermission': 'Hanya pemilik yang dapat mengekspor data atau menghentikan langganan.',

  'bo.data.export.title': 'Ekspor semua data',
  'bo.data.export.desc':
    'File ZIP berisi satu file JSON Lines per tabel — pesanan, tagihan, pembayaran, buku stok, pemasok, staf, dan log audit. Siap dalam beberapa menit; setiap unduhan tersedia selama {days} hari.',
  'bo.data.export.request': 'Minta ekspor',
  'bo.data.export.requesting': 'Meminta…',
  'bo.data.export.requested': 'Ekspor diminta. File akan muncul di bawah begitu siap.',
  'bo.data.export.quota': '{used} dari {limit} ekspor diminta dalam 24 jam terakhir.',
  'bo.data.export.busy': 'Ekspor sedang disiapkan. Anda bisa meminta lagi setelah selesai.',
  'bo.data.export.empty':
    'Belum ada ekspor — minta satu dan file akan muncul di sini dalam beberapa menit.',
  'bo.data.export.sensitive':
    'File ini berisi data pribadi staf dan tamu Anda. Simpan dengan aman dan bagikan hanya kepada yang memerlukannya.',
  'bo.data.export.col.requested': 'Diminta',
  'bo.data.export.col.by': 'Diminta oleh',
  'bo.data.export.col.status': 'Status',
  'bo.data.export.col.size': 'Ukuran',
  'bo.data.export.col.until': 'Tersedia sampai',
  'bo.data.export.col.action': 'Unduh',
  'bo.data.export.download': 'Unduh',
  'bo.data.export.downloading': 'Menyiapkan…',
  'bo.data.export.downloadAria': 'Unduh ekspor yang diminta {date}',
  'bo.data.export.status.pending': 'Menunggu',
  'bo.data.export.status.running': 'Disiapkan',
  'bo.data.export.status.ready': 'Siap',
  'bo.data.export.status.failed': 'Gagal',
  'bo.data.export.status.expired': 'Kedaluwarsa',
  'bo.data.export.failedHint': 'Minta ekspor baru; jika terus gagal, hubungi dukungan.',

  'bo.data.retention.title': 'Berapa lama data disimpan',
  'bo.data.retention.desc':
    'Masa simpan per jenis data. Catatan keuangan dan log audit tidak pernah dihapus selama langganan aktif.',
  'bo.data.retention.afterCancel': 'Semua data setelah berhenti berlangganan',
  'bo.data.retention.exports': 'Unduhan ekspor',
  'bo.data.retention.financial': 'Catatan keuangan (pesanan, tagihan, pembayaran, stok)',
  'bo.data.retention.audit': 'Log audit',
  'bo.data.retention.guest': 'Nama tamu pada pesanan bawa pulang dan pesan antar',
  'bo.data.retention.sessions': 'Sesi masuk yang sudah berakhir',
  'bo.data.retention.days': '{count} hari',
  'bo.data.retention.years': 'Minimal {count} tahun',
  'bo.data.retention.afterClosing': '{count} hari setelah ditutup',
  'bo.data.retention.backups':
    'Data yang dihapus masih bisa ada di cadangan database hingga {days} hari berikutnya, setelah itu hilang permanen.',

  'bo.data.cancel.title': 'Hentikan langganan',
  'bo.data.cancel.desc': 'Menghentikan layanan untuk semua cabang dan seluruh staf.',
  'bo.data.cancel.explain':
    'Semua orang selain Anda akan dikeluarkan dan restoran tidak bisa lagi menerima pesanan. Data Anda disimpan selama {days} hari agar bisa diekspor, atau minta tim dukungan memulihkan akun. Setelah itu data dihapus permanen dari database dan penyimpanan file.',
  'bo.data.cancel.button': 'Hentikan langganan…',
  'bo.data.cancel.dialogTitle': 'Hentikan langganan {tenant}?',
  'bo.data.cancel.dialogBody':
    'Semua data akan dihapus permanen pada {date}. Unduh ekspor terlebih dahulu jika Anda memerlukan catatan Anda.',
  'bo.data.cancel.reason': 'Alasan berhenti',
  'bo.data.cancel.reasonHint': 'Dicatat di log audit.',
  'bo.data.cancel.reasonRequired': 'Isi alasan minimal 3 karakter.',
  'bo.data.cancel.confirmLabel': 'Ketik {slug} untuk konfirmasi',
  'bo.data.cancel.confirmMismatch': 'Tidak sama dengan ID akun.',
  'bo.data.cancel.confirm': 'Hentikan langganan',
  'bo.data.cancel.confirming': 'Menghentikan…',
  'bo.data.cancel.keep': 'Tetap berlangganan',
  'bo.data.cancel.done': 'Langganan dihentikan. Data Anda disimpan sampai {date}.',
  'bo.data.cancelled.title': 'Langganan dihentikan',
  'bo.data.cancelled.body':
    'Dihentikan pada {cancelled}. Semua data akan dihapus permanen pada {deletion}. Hubungi tim dukungan sebelum tanggal itu untuk memulihkan akun.',
};
